import Screenshots from './screenshots';
import Download from './download';
import Blog from './blog';
import Pricing from './pricing/list';
import Team from './team';
import Contact from './contact';

const HomeContent = () =>{
  return(
    <>
      <Screenshots />
      <Download />
      <Blog />
      <Pricing />
      <Team />
      <Contact />
    </>
  )
}
export default HomeContent;